import React from 'react';
import css from './EditListingDescriptionForm.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { required, composeValidators } from '../../util/validators';
import { FieldCheckboxGroup, FieldSelect, IconDelete } from '../../components';
import { Field } from 'react-final-form';

const EditListingDescriptionQuestionForm = ({ name, index, subcategory, fields }) => {
  return (
    <div className={css.dynamicFieldWrapper} key={name}>
      <div
        className={css.closeIconWrapper}
        onClick={() => {
          if (index > 0) {
            fields.remove(index);
          }
        }}
      >
        {index !== 0 && <IconDelete />}
      </div>
      <label className={css.dynamicItemLabel}>Question {index + 1}</label>
      <Field
        name={`${name}.question`}
        className={css.dynamicField}
        component="input"
        placeholder={'Lorem ipsum?'}
      />
      <FieldCheckboxGroup
        className={css.optionField}
        name={`${name}.subcategory`}
        id={`${name}.subcategory`}
        options={subcategory}
        twoColumns={true}
        label={'Select Subcategory'}
        validate={composeValidators(required('You need to complete this field'))}
      />
      {/* <FieldSelect
        className={css.optionField}
        name={`${name}.subcategory`}
        id={'selectSubcategory'}
        label={'Select Subcategory'}
        validate={composeValidators(required('You need to complete this field'))}
      >
        <option key={''} value={''} default hidden>
          {'Select an option'}
        </option>
        {subcategory.map(c => (
          <option key={c.key} value={c.key}>
            {c.label}
          </option>
        ))}
      </FieldSelect> */}
    </div>
  );
};

export default EditListingDescriptionQuestionForm;
